import { useLocation, Navigate } from 'react-router-dom';
import useAuth from '../Hooks/useAuth';

export interface GuardedRouteProps {
    children: any;
}

const GuardedRoute = ({ children }: GuardedRouteProps) => {
	const { isAuthenticated } = useAuth();
	const location = useLocation();

    const url = location.pathname && location.pathname !== '' ? `?url=${encodeURIComponent(location.pathname + location.search)}` : '';

	if (!isAuthenticated)
		return <Navigate to={`/${url}`} replace />;

	return children;
};

export default GuardedRoute;
